export const weeklyMovementDateFormat = 'MMMM DD, YYYY';
export const calendarcompatibleDateFormat = 'yyyy-MM-dd';
